  import {
      Box,
      Dialog,
      Fade,
      IconButton,
      Menu,
    } from '@mui/material'
    import {
      Close as CloseIcon,
    } from '@mui/icons-material'
  import {DropDownMenuProps} from '../../models/props.models'
  import Constants from '../../constants'


   const DropDownMenu = ({children, anchorEl, onlyXs, onMenuClose }: DropDownMenuProps) => {
      return Boolean(anchorEl) ? (
        !onlyXs ? (
          <Menu
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            keepMounted
            onClose={onMenuClose}
            TransitionComponent={Fade}
            style={{ marginTop: '95px' }}
            transformOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            // slotProps allows passing props to internal MUI components like Paper
            slotProps={{
              paper: {
                sx: {minWidth: anchorEl?.offsetWidth}
              }
            }}
            >
            {children} 
          </Menu>
        ) : (
          <Dialog open={Boolean(anchorEl)} onClose={onMenuClose} fullScreen TransitionComponent={Fade}>
            <Box
              height={Constants.ui.appBarSize + 'px'}
              padding="20px"
              display="flex"
              justifyContent="center"
              alignContent="flex-end">
              <IconButton sx={{ marginLeft: 'auto' }} onClick={onMenuClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box>{children}</Box>
          </Dialog>
        )
      ) : (
        <></>
      )
    }

    export default DropDownMenu